<gt-dialog-header message="{{'contacts.col_header' | translate }}" icon="view_column" (closing)="closeDialog()"></gt-dialog-header>

<mat-dialog-content>
  <mat-list>
    <mat-list-item *ngFor="let column of allColumns">
      <mat-slide-toggle class="column-slider"
                        [checked]="isDisplayed(column)"
                        (change)="columnToggled(column, $event.source.checked)"
                        color="primary">{{getTranslationKey(column) | translate}}</mat-slide-toggle>
    </mat-list-item>
  </mat-list>
</mat-dialog-content>

<mat-dialog-actions align="end" style="margin-top: 16px;">
  <button mat-button id="btn-reset" color="primary" (click)="resetSettings()">{{ 'global.reset' | translate }}</button>
  <button mat-button id="btn-close" color="primary" (click)="closeDialog()">{{ 'global.back' | translate }}</button>
</mat-dialog-actions>
